/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.branding.rpc.BrandVoiceV1Rpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getByBusinessUnitRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandVoiceV1Rpc',
  rpcName: 'getByBusinessUnit',
  auth: 'app',
  fingerprint: 'EpKGt95IsPJMJIUc81-xwJuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPrimaryRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandVoiceV1Rpc',
  rpcName: 'getPrimary',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABMJIUc81-xwJuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandVoiceV1Rpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'OoWY5fELX05MJIUc81-xwJuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.branding.rpc.BrandVoiceV1Rpc',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: 'sZwduopZ5O2OUe2e_r4XmZuw9e6Svwtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};